import React from "react";
import { MapPin } from "lucide-react";
import { CITIES } from "../../data/content";
import { Reveal, Eyebrow } from "./Reveal";

export const ServiceArea = () => (
  <section id="service-area" className="relative py-24 md:py-32 bg-[#111111]">
    <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-14 items-center">
      <div>
        <Reveal><Eyebrow>Service Area</Eyebrow></Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-heading font-extrabold uppercase text-white text-4xl md:text-5xl lg:text-6xl tracking-tight mt-3">
            Serving <span className="text-[#F56FB4]">Delaware County</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="text-white/60 mt-4 max-w-lg leading-relaxed">
            Proudly based in Chester, PA — we bring fast, reliable property
            transformation to communities across Delaware County and beyond.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="flex flex-wrap gap-2.5 mt-8">
            {CITIES.map((c) => (
              <span
                key={c}
                data-testid={`city-${c.replace(/\s+/g, "-").toLowerCase()}`}
                className="inline-flex items-center gap-1.5 rounded-full border border-white/12 bg-[#161616] px-4 py-2 text-sm text-white/80 hover:border-[#53C653]/60 hover:text-white transition-colors duration-200"
              >
                <MapPin size={14} className="text-[#53C653]" />
                {c}
              </span>
            ))}
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.1}>
        <div className="relative aspect-square md:aspect-[4/3] rounded-[2rem] border border-white/10 bg-[#0d0d0d] overflow-hidden">
          <iframe
            title="Lotus Property Services — Delaware County service area"
            src="https://www.google.com/maps?q=Delaware+County,+Pennsylvania&z=10&output=embed"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="absolute inset-0 h-full w-full border-0"
            allowFullScreen
          />
          <div className="absolute bottom-5 left-5 rounded-2xl bg-[#111111]/85 backdrop-blur-md border border-white/10 px-5 py-3 pointer-events-none">
            <p className="text-xs text-white/50 uppercase tracking-wide">Headquarters</p>
            <p className="font-heading font-bold text-white">Chester, Pennsylvania</p>
          </div>
          <a
            href="https://www.google.com/maps/dir/?api=1&destination=Chester,+PA"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="get-directions-btn"
            className="absolute bottom-5 right-5 inline-flex items-center gap-2 rounded-full bg-[#F56FB4] px-4 py-2 text-sm font-semibold text-white shadow-[0_0_20px_rgba(245,111,180,0.4)] hover:scale-105 transition-transform"
          >
            <MapPin size={15} /> Get Directions
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);

export default ServiceArea;
